/**
 * Transient holder for Step 1's (email, password) between the two screens
 * of the email-registration flow. Deliberately module-level JS memory only
 * — NOT localStorage/sessionStorage/URL params/history state. A hard
 * refresh resets this module, which is exactly the desired behavior: if
 * Firebase account creation (Step 2's submit) hasn't happened yet, there is
 * nothing safe to resume, and the user is sent back to Step 1.
 *
 * Once Step 2 successfully creates the Firebase account, this is no longer
 * needed (the user is authenticated — see the registration-status hook for
 * the resume path) and is cleared.
 */

interface PendingSignup {
  email:    string;
  password: string;
}

let pending: PendingSignup | null = null;

export function setPendingSignup(email: string, password: string): void {
  pending = { email, password };
}

export function getPendingSignup(): PendingSignup | null {
  return pending;
}

export function clearPendingSignup(): void {
  pending = null;
}
